const services = [
  {
    icon: 'ri-bank-card-line',
    title: '신용카드 한도대출',
    desc: '신용카드 한도를 활용한 빠른 대출 서비스. 카드 한도 내에서 필요한 금액을 즉시 이용하세요.',
    tag: '인기',
  },
  {
    icon: 'ri-user-heart-line',
    title: '신용카드 소지자대출',
    desc: '신용카드를 보유하고 계신 분이라면 누구나 신청 가능한 대출 상품입니다.',
    tag: '',
  },
  {
    icon: 'ri-percentage-line',
    title: '신용카드잔여한도대출',
    desc: '카드 한도를 기반으로 대출을 진행합니다. 카드한도를 최대한 활용하실 수 있습니다.',
    tag: '',
  },
  {
    icon: 'ri-smartphone-line',
    title: '신용카드 비대면대출',
    desc: '방문 없이 온라인/전화로 신청 완료. 언제 어디서나 편리하게 대출을 진행하세요.',
    tag: '비대면',
  },
  {
    icon: 'ri-building-2-line',
    title: '법인카드대출',
    desc: '법인카드를 이용하여 대출 서비스를 제공합니다. 기업의 자금을 신속하게 처리해 드립니다.',
    tag: '',
  },
  {
    icon: 'ri-exchange-dollar-line',
    title: '신용카드 대출',
    desc: '다양한 신용카드 서비스를 제공합니다. 최상의조건을 찾아드립니다.',
    tag: '전체',
  },
];

export default function ServicesSection() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" className="py-12 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-8 md:mb-16">
          <span className="inline-block bg-[#03C75A]/10 text-[#03C75A] text-xs sm:text-sm font-bold px-3 sm:px-4 py-1.5 rounded-full mb-3 sm:mb-4">
            서비스 안내
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-gray-900 mb-3 sm:mb-4">신용카드 전문 대출 서비스</h2>
          <p className="text-gray-500 text-sm sm:text-lg max-w-xl mx-auto">
            7년 경력의 전문업체가 카드 관련 모든 대출을 처리해 드립니다.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {services.map((svc) => (
            <div
              key={svc.title}
              className="group relative bg-white border border-gray-100 rounded-2xl p-5 sm:p-6 hover:border-[#03C75A]/30 hover:bg-[#f0fff7] transition-all duration-300 cursor-default"
            >
              {svc.tag && (
                <span className="absolute top-4 right-4 bg-[#03C75A] text-white text-xs font-bold px-2.5 py-1 rounded-full">
                  {svc.tag}
                </span>
              )}
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-[#03C75A]/10 rounded-xl mb-3 sm:mb-4 group-hover:bg-[#03C75A] transition-colors duration-300">
                <i className={`${svc.icon} text-xl sm:text-2xl text-[#03C75A] group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-1.5 sm:mb-2">{svc.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed mb-3 sm:mb-4">{svc.desc}</p>
              <a
                href="#contact"
                onClick={(e) => { e.preventDefault(); handleClick('#contact'); }}
                className="inline-flex items-center gap-1 text-sm font-semibold text-[#03C75A] hover:gap-2 transition-all cursor-pointer"
              >
                상담 신청하기 <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>

        {/* Bottom Banner */}
        <div className="mt-8 sm:mt-12 bg-gradient-to-r from-[#03C75A] to-[#00A843] rounded-2xl p-5 sm:p-8 flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-6 text-center sm:text-left">
          <div>
            <p className="text-white/80 text-xs sm:text-sm mb-1">원하시는 서비스가 없으신가요?</p>
            <p className="text-white text-lg sm:text-2xl font-black">전화 한 통으로 모든 상담 가능합니다</p>
          </div>
          <a
            href="tel:01066065909"
            className="flex items-center gap-2 bg-white text-[#03C75A] font-bold px-6 sm:px-8 py-3 sm:py-4 rounded-xl whitespace-nowrap hover:bg-gray-50 transition-colors cursor-pointer w-full sm:w-auto justify-center"
          >
            <i className="ri-phone-fill text-lg"></i>
            010-6606-5909
          </a>
        </div>
      </div>
    </section>
  );
}
